export enum EbookSalesStatusEnum {
  PROMOTION_NOT_START_YET = 'PROMOTION_NOT_START_YET',
  PROMOTION_PERIOD = 'PROMOTION_PERIOD',
  PROMOTION_ENDED = 'PROMOTION_ENDED',
  PROMOTION_CLOSED = 'PROMOTION_CLOSED',
}

export const ebookSalesStatusValue = {
  [EbookSalesStatusEnum.PROMOTION_NOT_START_YET]: 'ยังไม่ถึงช่วงโปรโมชั่น',
  [EbookSalesStatusEnum.PROMOTION_PERIOD]: 'อยู่ในช่วงโปรโมชั่น',
  [EbookSalesStatusEnum.PROMOTION_ENDED]: 'หมดอายุ',
  [EbookSalesStatusEnum.PROMOTION_CLOSED]: 'ปิดโปรโมชั่น',
}
